// removed by extract-text-webpack-plugin
module.exports = {"controlsContainer":"carousel__controlsContainer--2FLnJ","sliderButton":"carousel__sliderButton--19eGk","nextSlide":"carousel__nextSlide--4r8UT carousel__sliderButton--19eGk","prevSlide":"carousel__prevSlide--uFWCT carousel__sliderButton--19eGk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Carousel/carousel.css
// module id = 5myL
// module chunks = 0